import React from 'react';
import { toast } from 'react-toastify';
import { ArcSocketContext } from '@src/core/socket';
import { CommandStatusEnum } from '@src/features/order/entities';
import { EnRouteCommandEnum, EnRouteEventTypeEnum } from '@src/features/order/pages/take-off-to-en-route-page/entities';

export const useRecording = (serialNumber: string) => {
  const { arcSocket } = React.useContext(ArcSocketContext);
  const [isRecording, setIsRecording] = React.useState(false);

  React.useEffect(() => {
    const socket = arcSocket();
    if (!socket || !serialNumber) return;

    const onMessage = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data ?? '{}');

        if (data.type === 'COMMAND_STATUS' &&
            data.command === CommandStatusEnum.REQUEST_RECORDING &&
            (data.serialNumber === serialNumber || !data.serialNumber)) {

          if (data.status === 'ERROR') {
            toast.error('[REQUEST_RECORDING]: Something went wrong!');
            return;
          }

          setIsRecording(prev => !prev);
          toast.success(data.status ?? '');
        }
      } catch (_) {
        // ignore malformed messages
      }
    };

    socket.addEventListener('message', onMessage);
    return () => {
      socket.removeEventListener('message', onMessage);
    };
  }, [arcSocket, serialNumber]);

  React.useEffect(() => {
    return () => setIsRecording(false);
  }, []);

  const requestRecording = React.useCallback(() => {
    const socket = arcSocket();
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({
        type: EnRouteEventTypeEnum.CAMERA_COMMAND,
        command: EnRouteCommandEnum.REQUEST_RECORDING,
        serialNumber,
      }));
    }
  }, [arcSocket, serialNumber]);

  return { isRecording, requestRecording };
};
